var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAToZ(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#347af0;}.a{stroke:#707070;opacity:0;}.c{stroke:none;}.d{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 17
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.25 2.25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.026)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M4.258,0h-.8L1.5,5.6H2.611l.295-.842H4.787l.29.842H6.19ZM3.273,3.708l.579-1.656.571,1.656Z",
    transform: "translate(-1.496)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.936)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M269.348,9.487l-2,2V0H266.3V11.486l-2-2-.744.744,3.269,3.269,3.269-3.269Z",
    transform: "translate(-263.555)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 7.89)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M5.286,299.247H.5V300.3H3.7L.5,304.023v.827H5.233V303.8H2.081l3.2-3.724Z",
    transform: "translate(-0.499 -299.247)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAToZ);
export default __webpack_public_path__ + "static/media/aToZ.f8ba8a71c3093df4c9988fec919eb1b3.svg";
export { ForwardRef as ReactComponent };